import { render, staticRenderFns } from "./CustomDropdown.vue?vue&type=template&id=4ffbbfa4&scoped=true"
import script from "./CustomDropdown.vue?vue&type=script&lang=js"
export * from "./CustomDropdown.vue?vue&type=script&lang=js"
import style0 from "./CustomDropdown.vue?vue&type=style&index=0&id=4ffbbfa4&prod&lang=scss&scoped=true"
import style1 from "./CustomDropdown.vue?vue&type=style&index=1&id=4ffbbfa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffbbfa4",
  null
  
)

export default component.exports